import React from "react";
import {
  globalBettingHouses,
  normalBetHome,
} from "./variables/VariablesFilterSurebet";
import { useContext, useEffect } from "react";
import { Context } from "../App";
export default function FilterDesktopBettingHouseModal(props) {
  const {
    statusMode,
    inputSearchRef,
    searchTerm,
    handleSearchChange,
    clearSearch,
    filteredNewListBetHomesSorted,
    warningBetHome,
    exchangeBetHome,
    listBettingHousesUnregulated,
    requiredBetHomeFrontEnd,
    betHomeFrontEnd,
    warningBetHomeMessages,
    warningBetHomeIcons,
    newListBetHome,
    betHomeNoLimit,
    matchesSearch,
    EnabledDisablebBethome,
    allBetHome,
    filteredExchangeBetHome,
    filteredSportsbookBetHome,
    hasAnyBetHomeResult,
    Tooltip,
    quantityAllBetHome,
    markAll,
    saveFilterBetHome,
  } = props;

  const { accountFeatures } = useContext(Context);

  let listBettingHouseToSkip = [];
  const globalBettingHousesSearch = 
    
      filteredNewListBetHomesSorted.filter((item) => {
        if (listBettingHouseToSkip.includes(item["name"])) {
          return false;
        } else if (item["name"] === "Stake") {
          item["allClones"] = [];
          listBettingHouseToSkip.push("Stake");
        }

        return globalBettingHouses.includes(item["name"]);
      }) 
  ;

  const normalBettingHousesSearch = filteredNewListBetHomesSorted.filter(
    (item) => {
      if (listBettingHouseToSkip.includes(item["name"])) {
        let xxx = listBettingHouseToSkip.filter(
          (item000) => item000 != item["name"],
        );
        listBettingHouseToSkip = xxx;
        return false;
      }

      return normalBetHome.includes(item["name"]);
    },
  );
  
  return (
    <div
      className="modal fade alt_margin_x"
      id="filterBetHome"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg d-flex justify-content-center mt-3">
        <div
          className="modal-content moldal-lg "
          style={{ width: "fit-content", minWidth: "1000px" }}
        >
          <div
            className={`modal-header ${
              statusMode ? "bgDark borderColor textGray" : ""
            }`}
          >
            <div className="modal-title h4" id="exampleModalLabel">
              Casas de Apostas
            </div>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div
            className={`modal-body px-0 pb-0  ${statusMode ? "bgDark" : ""}`}
            style={{ height: "700px", overflow: "auto" }}
          >
            <div className="px-3 py-2">
              <label
                htmlFor="search-bet-home-desktop"
                className="visually-hidden"
              >
                Pesquisar casa de apostas
              </label>
              <div className="filter-search-wrapper">
                <input
                  ref={inputSearchRef}
                  id="search-bet-home-desktop"
                  type="text"
                  className={`form-control form-control-sm ${
                    statusMode ? "bgDark borderColor textGray" : ""
                  }`}
                  placeholder="Pesquisar casa de apostas..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                  autoComplete="off"
                />
                {searchTerm && (
                  <button
                    type="button"
                    className={`filter-search-clear-btn ${
                      statusMode ? "textGray" : "text-secondary"
                    }`}
                    aria-label="Limpar pesquisa"
                    onClick={clearSearch}
                  >
                    ×
                  </button>
                )}
              </div>
            </div>
            {accountFeatures.current.includes("global") && (
              <>
                <div className="w-100 style-filter-surebet-desktop-global">
                  {globalBettingHousesSearch &&
                    globalBettingHousesSearch.map((value, index) => {
                      let nameBetHomeFilterLower = value["name"].toLowerCase();
                      let isEnableWarning =
                        nameBetHomeFilterLower in warningBetHome ? true : false;
                      return (
                        <React.Fragment key={index}>
                          <div
                            className={`form-check gap-2 d-flex ${
                              exchangeBetHome.includes(value["name"])
                                ? "ms-4"
                                : "mx-3"
                            } ${statusMode ? "textGray" : ""}
                            ${listBettingHousesUnregulated.includes(nameBetHomeFilterLower) ? "align-items-start" : "align-items-center"}
                            `}
                          >
                            <input
                              type="checkbox"
                              id={"casasDeApostasGlobal" + index}
                              className={`form-check-input ${
                                requiredBetHomeFrontEnd.includes(
                                  nameBetHomeFilterLower,
                                ) === true
                                  ? "cus"
                                  : ""
                              }`}
                              name={nameBetHomeFilterLower}
                              checked={
                                typeof betHomeFrontEnd === "object" &&
                                betHomeFrontEnd &&
                                betHomeFrontEnd.includes(nameBetHomeFilterLower)
                              }
                              onChange={EnabledDisablebBethome}
                            />
                            {nameBetHomeFilterLower in warningBetHome ? (
                              <img
                                data-tooltip-content={
                                  isEnableWarning
                                    ? warningBetHomeMessages[
                                        warningBetHome[nameBetHomeFilterLower]
                                      ]
                                    : undefined
                                }
                                data-tooltip-id={
                                  isEnableWarning
                                    ? "tooltip-surebet"
                                    : undefined
                                }
                                className="style-icon-alert-filter"
                                src={
                                  warningBetHomeIcons[
                                    warningBetHome[nameBetHomeFilterLower]
                                  ]
                                }
                              />
                            ) : (
                              ""
                            )}
                            <label
                              title=""
                              htmlFor={"casasDeApostasGlobal" + index}
                              className="form-check-label d-flex"
                              name={nameBetHomeFilterLower}
                              style={{ flexWrap: "wraps" }}
                            >
                              

                              <span className="nameBetHomeLabelDesktop">
                                {value["name"]}
                              </span>
                              <>
                                <span class="badge rounded-1 bg-info style-text-no-limit ms-1 style-height-fit-content">
                                  Global
                                </span>
                              </>
                              {newListBetHome.includes(
                                nameBetHomeFilterLower,
                              ) === true ? (
                                <span
                                  class="badge rounded-1 text-bg-warning ms-1 style-height-fit-content"
                                  style={{ fontSize: "8px" }}
                                >
                                  New
                                </span>
                              ) : (
                                ""
                              )}
                              {listBettingHousesUnregulated.includes(
                                nameBetHomeFilterLower,
                              ) && (
                                <>
                                  <span class="badge rounded-1 style-bg-dark-green style-text-no-limit ms-1 style-height-fit-content">
                                    Não Regulamentada
                                  </span>
                                </>
                              )}

                              {betHomeNoLimit.includes(
                                nameBetHomeFilterLower,
                              ) && (
                                <>
                                  <span class="badge rounded-1 style-bg-dark-green style-text-no-limit ms-1 style-height-fit-content">
                                    Não Limita
                                  </span>
                                </>
                              )}

                              
                            </label>
                          </div>

                          {value["hasClone"] ? (
                            <>
                              {value["allClones"]
                                .filter((itemClone) => matchesSearch(itemClone))
                                .map((itemClone, indexClone) => {
                                  let nameCloneBetHomeFilterLower =
                                    itemClone.toLocaleLowerCase();
                                  return (
                                    <div
                                      className={` form-check gap-2 d-flex align-items-center ${
                                        exchangeBetHome.includes(itemClone)
                                          ? "ms-4"
                                          : "mx-3"
                                      } ${statusMode ? "textGray" : ""} ms-5`}
                                      key={indexClone}
                                    >
                                      <input
                                        type="checkbox"
                                        id={
                                          "casasDeApostasGlobalClone" +
                                          value["name"] +
                                          indexClone
                                        }
                                        className={`form-check-input ${
                                          requiredBetHomeFrontEnd.includes(
                                            nameCloneBetHomeFilterLower,
                                          ) === true
                                            ? "cus"
                                            : ""
                                        }`}
                                        name={nameCloneBetHomeFilterLower}
                                        checked={
                                          typeof betHomeFrontEnd === "object" &&
                                          betHomeFrontEnd &&
                                          betHomeFrontEnd.includes(
                                            nameCloneBetHomeFilterLower,
                                          )
                                        }
                                        onChange={EnabledDisablebBethome}
                                      />
                                      {nameCloneBetHomeFilterLower in
                                      warningBetHome ? (
                                        <img
                                          data-tooltip-content={
                                            isEnableWarning
                                              ? warningBetHomeMessages[
                                                  warningBetHome[
                                                    nameCloneBetHomeFilterLower
                                                  ]
                                                ]
                                              : undefined
                                          }
                                          data-tooltip-id={
                                            isEnableWarning
                                              ? "tooltip-surebet"
                                              : undefined
                                          }
                                          className="style-icon-alert-filter"
                                          src={
                                            warningBetHomeIcons[
                                              warningBetHome[
                                                nameCloneBetHomeFilterLower
                                              ]
                                            ]
                                          }
                                        />
                                      ) : (
                                        ""
                                      )}
                                      <label
                                        title=""
                                        htmlFor={
                                          "casasDeApostasGlobalClone" +
                                          value["name"] +
                                          indexClone
                                        }
                                        className="form-check-label d-flex"
                                        name={nameCloneBetHomeFilterLower}
                                      >
                                        <span className="nameBetHomeLabelDesktop">
                                          {itemClone}
                                        </span>

                                          <>
                                          <span class="badge rounded-1 bg-info style-text-no-limit ms-1 style-height-fit-content">
                                            Global
                                          </span>
                                        </>


                                        {newListBetHome.includes(
                                          nameCloneBetHomeFilterLower,
                                        ) === true ? (
                                          <span
                                            class="badge rounded-1 text-bg-warning ms-1 style-height-fit-content"
                                            style={{ fontSize: "8px" }}
                                          >
                                            New
                                          </span>
                                        ) : (
                                          ""
                                        )}
                                        {betHomeNoLimit.includes(
                                          nameCloneBetHomeFilterLower,
                                        ) && (
                                          <>
                                            <span class="badge rounded-1 style-bg-dark-green style-text-no-limit ms-1 style-height-fit-content">
                                              Não Limita
                                            </span>
                                          </>
                                        )}

                                      

                                        {listBettingHousesUnregulated.includes(
                                          nameCloneBetHomeFilterLower,
                                        ) && (
                                          <>
                                            <span class="badge rounded-1 style-bg-dark-green style-text-no-limit ms-1 style-height-fit-content">
                                              Não Regulamentada
                                            </span>
                                          </>
                                        )}
                                      </label>
                                    </div>
                                  );
                                })}
                            </>
                          ) : (
                            ""
                          )}
                        </React.Fragment>
                      );
                    })}
                </div>

                <hr />
              </>
            )}
            <div className="w-100 style-filter-surebet-desktop">
              {normalBettingHousesSearch &&
                normalBettingHousesSearch.map((value, index) => {
                  let nameBetHomeFilterLower = value["name"].toLowerCase();
                  let isEnableWarning =
                    nameBetHomeFilterLower in warningBetHome ? true : false;
                  return (
                    <React.Fragment key={index}>
                      <div
                        className={`form-check gap-2 d-flex ${
                          exchangeBetHome.includes(value["name"])
                            ? "ms-4"
                            : "mx-3"
                        } ${statusMode ? "textGray" : ""}
                            ${listBettingHousesUnregulated.includes(nameBetHomeFilterLower) ? "align-items-start" : "align-items-center"}
                            `}
                      >
                        <input
                          type="checkbox"
                          id={"casasDeApostas" + index}
                          className={`form-check-input ${
                            requiredBetHomeFrontEnd.includes(
                              nameBetHomeFilterLower,
                            ) === true
                              ? "cus"
                              : ""
                          }`}
                          name={nameBetHomeFilterLower}
                          checked={
                            typeof betHomeFrontEnd === "object" &&
                            betHomeFrontEnd &&
                            betHomeFrontEnd.includes(nameBetHomeFilterLower)
                          }
                          onChange={EnabledDisablebBethome}
                        />
                        {nameBetHomeFilterLower in warningBetHome ? (
                          <img
                            data-tooltip-content={
                              isEnableWarning
                                ? warningBetHomeMessages[
                                    warningBetHome[nameBetHomeFilterLower]
                                  ]
                                : undefined
                            }
                            data-tooltip-id={
                              isEnableWarning ? "tooltip-surebet" : undefined
                            }
                            className="style-icon-alert-filter"
                            src={
                              warningBetHomeIcons[
                                warningBetHome[nameBetHomeFilterLower]
                              ]
                            }
                          />
                        ) : (
                          ""
                        )}
                        <label
                          title=""
                          htmlFor={"casasDeApostas" + index}
                          className="form-check-label d-flex"
                          name={nameBetHomeFilterLower}
                          style={{ flexWrap: "wraps" }}
                        >
                          <span className="nameBetHomeLabelDesktop">
                            {value["name"]}
                          </span>
                          {newListBetHome.includes(nameBetHomeFilterLower) ===
                          true ? (
                            <span
                              class="badge rounded-1 text-bg-warning ms-1 style-height-fit-content"
                              style={{ fontSize: "8px" }}
                            >
                              New
                            </span>
                          ) : (
                            ""
                          )}
                          {listBettingHousesUnregulated.includes(
                            nameBetHomeFilterLower,
                          ) && (
                            <>
                              <span class="badge rounded-1 style-bg-dark-green style-text-no-limit ms-1 style-height-fit-content">
                                Não Regulamentada
                              </span>
                            </>
                          )}

                          {betHomeNoLimit.includes(nameBetHomeFilterLower) && (
                            <>
                              <span class="badge rounded-1 style-bg-dark-green style-text-no-limit ms-1 style-height-fit-content">
                                Não Limita
                              </span>
                            </>
                          )}
                        </label>
                      </div>

                      {value["hasClone"] ? (
                        <>
                          {value["allClones"]
                            .filter((itemClone) => matchesSearch(itemClone))
                            .map((itemClone, indexClone) => {
                              let nameCloneBetHomeFilterLower =
                                itemClone.toLocaleLowerCase();
                              return (
                                <div
                                  className={` form-check gap-2 d-flex align-items-center ${
                                    exchangeBetHome.includes(itemClone)
                                      ? "ms-4"
                                      : "mx-3"
                                  } ${statusMode ? "textGray" : ""} ms-5`}
                                  key={indexClone}
                                >
                                  <input
                                    type="checkbox"
                                    id={
                                      "casasDeApostasClone" +
                                      value["name"] +
                                      indexClone
                                    }
                                    className={`form-check-input ${
                                      requiredBetHomeFrontEnd.includes(
                                        nameCloneBetHomeFilterLower,
                                      ) === true
                                        ? "cus"
                                        : ""
                                    }`}
                                    name={nameCloneBetHomeFilterLower}
                                    checked={
                                      typeof betHomeFrontEnd === "object" &&
                                      betHomeFrontEnd &&
                                      betHomeFrontEnd.includes(
                                        nameCloneBetHomeFilterLower,
                                      )
                                    }
                                    onChange={EnabledDisablebBethome}
                                  />
                                  {nameCloneBetHomeFilterLower in
                                  warningBetHome ? (
                                    <img
                                      data-tooltip-content={
                                        isEnableWarning
                                          ? warningBetHomeMessages[
                                              warningBetHome[
                                                nameCloneBetHomeFilterLower
                                              ]
                                            ]
                                          : undefined
                                      }
                                      data-tooltip-id={
                                        isEnableWarning
                                          ? "tooltip-surebet"
                                          : undefined
                                      }
                                      className="style-icon-alert-filter"
                                      src={
                                        warningBetHomeIcons[
                                          warningBetHome[
                                            nameCloneBetHomeFilterLower
                                          ]
                                        ]
                                      }
                                    />
                                  ) : (
                                    ""
                                  )}
                                  <label
                                    title=""
                                    htmlFor={
                                      "casasDeApostasClone" +
                                      value["name"] +
                                      indexClone
                                    }
                                    className="form-check-label d-flex"
                                    name={nameCloneBetHomeFilterLower}
                                  >
                                    <span className="nameBetHomeLabelDesktop">
                                      {itemClone}
                                    </span>
                                    {newListBetHome.includes(
                                      nameCloneBetHomeFilterLower,
                                    ) === true ? (
                                      <span
                                        class="badge rounded-1 text-bg-warning ms-1 style-height-fit-content"
                                        style={{ fontSize: "8px" }}
                                      >
                                        New
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                    {betHomeNoLimit.includes(
                                      nameCloneBetHomeFilterLower,
                                    ) && (
                                      <>
                                        <span class="badge rounded-1 style-bg-dark-green style-text-no-limit ms-1 style-height-fit-content">
                                          Não Limita
                                        </span>
                                      </>
                                    )}

                                    {listBettingHousesUnregulated.includes(
                                      nameCloneBetHomeFilterLower,
                                    ) && (
                                      <>
                                        <span class="badge rounded-1 style-bg-dark-green style-text-no-limit ms-1 style-height-fit-content">
                                          Não Regulamentada
                                        </span>
                                      </>
                                    )}
                                  </label>
                                </div>
                              );
                            })}
                        </>
                      ) : (
                        ""
                      )}
                    </React.Fragment>
                  );
                })}
            </div>

            <div className="d-flex">
              <div className="w-100 pe-2 mt-3 mb-2">
                {allBetHome &&
                  filteredExchangeBetHome.map((value, index) => {
                    let nameBetHomeFilterLower = value.toLowerCase();
                    let isEnableWarning =
                      nameBetHomeFilterLower in warningBetHome ? true : false;

                    return index === 0 ? (
                      <React.Fragment key={index}>
                        <h4 className="ms-3 mode-h4">Exchange</h4>
                        <div
                          className={`form-check gap-2 ms-4 d-flex align-items-center ${
                            statusMode ? "textGray" : ""
                          }`}
                        >
                          <input
                            type="checkbox"
                            id={"casasDeApostasExchange" + index}
                            className={`form-check-input ${
                              requiredBetHomeFrontEnd.includes(
                                nameBetHomeFilterLower,
                              ) === true
                                ? "cus"
                                : ""
                            }`}
                            name={nameBetHomeFilterLower}
                            checked={
                              typeof betHomeFrontEnd === "object" &&
                              betHomeFrontEnd &&
                              betHomeFrontEnd.includes(nameBetHomeFilterLower)
                            }
                            onChange={EnabledDisablebBethome}
                          />

                          {nameBetHomeFilterLower in warningBetHome ? (
                            <img
                              data-tooltip-content={
                                isEnableWarning
                                  ? warningBetHomeMessages[
                                      warningBetHome[nameBetHomeFilterLower]
                                    ]
                                  : undefined
                              }
                              data-tooltip-id={
                                isEnableWarning ? "tooltip-surebet" : undefined
                              }
                              className="style-icon-alert-filter"
                              src={
                                warningBetHomeIcons[
                                  warningBetHome[nameBetHomeFilterLower]
                                ]
                              }
                            />
                          ) : (
                            ""
                          )}

                          <label
                            title=""
                            htmlFor={"casasDeApostasExchange" + index}
                            className="form-check-label white-space-nowrap d-flex"
                            name={nameBetHomeFilterLower}
                          >
                            <span className="nameBetHomeLabelDesktop">
                              {value}
                            </span>
                            {newListBetHome.includes(nameBetHomeFilterLower) ===
                            true ? (
                              <span
                                class="badge rounded-1 text-bg-warning ms-1 style-height-fit-content"
                                style={{ fontSize: "8px" }}
                              >
                                New
                              </span>
                            ) : (
                              ""
                            )}

                            {betHomeNoLimit.includes(
                              nameBetHomeFilterLower,
                            ) && (
                              <>
                                <span class="badge rounded-1 style-bg-dark-green style-text-no-limit ms-1 style-height-fit-content">
                                  Não Limita
                                </span>
                              </>
                            )}

                            {listBettingHousesUnregulated.includes(
                              nameBetHomeFilterLower,
                            ) && (
                              <>
                                <span class="badge rounded-1 style-bg-dark-green style-text-no-limit ms-1 style-height-fit-content">
                                  Não Regulamentada
                                </span>
                              </>
                            )}
                          </label>
                        </div>
                      </React.Fragment>
                    ) : (
                      <div
                        className={`form-check gap-2 ms-4 d-flex align-items-center ${
                          statusMode ? "textGray" : ""
                        }`}
                        key={index}
                      >
                        <input
                          type="checkbox"
                          id={"casasDeApostasExchange" + index}
                          className={`form-check-input ${
                            requiredBetHomeFrontEnd.includes(
                              value.toLowerCase(),
                            ) === true
                              ? "cus"
                              : ""
                          }`}
                          name={value.toLowerCase()}
                          checked={
                            typeof betHomeFrontEnd === "object" &&
                            betHomeFrontEnd &&
                            betHomeFrontEnd.includes(value.toLowerCase())
                          }
                          onChange={EnabledDisablebBethome}
                        />

                        {nameBetHomeFilterLower in warningBetHome ? (
                          <img
                            data-tooltip-content={
                              isEnableWarning
                                ? warningBetHomeMessages[
                                    warningBetHome[nameBetHomeFilterLower]
                                  ]
                                : undefined
                            }
                            data-tooltip-id={
                              isEnableWarning ? "tooltip-surebet" : undefined
                            }
                            className="style-icon-alert-filter"
                            src={
                              warningBetHomeIcons[
                                warningBetHome[nameBetHomeFilterLower]
                              ]
                            }
                          />
                        ) : (
                          ""
                        )}

                        <label
                          title=""
                          htmlFor={"casasDeApostasExchange" + index}
                          className="form-check-label white-space-nowrap d-flex"
                          name={value.toLowerCase()}
                        >
                          <span className="nameBetHomeLabelDesktop">
                            {value}
                          </span>
                          {newListBetHome.includes(nameBetHomeFilterLower) ===
                          true ? (
                            <span
                              class="badge rounded-1 text-bg-warning ms-1 style-height-fit-content"
                              style={{ fontSize: "8px" }}
                            >
                              New
                            </span>
                          ) : (
                            ""
                          )}

                          {betHomeNoLimit.includes(nameBetHomeFilterLower) && (
                            <>
                              <span class="badge rounded-1 style-bg-dark-green style-text-no-limit ms-1 style-height-fit-content">
                                Não Limita
                              </span>
                            </>
                          )}

                          {listBettingHousesUnregulated.includes(
                            nameBetHomeFilterLower,
                          ) && (
                            <>
                              <span class="badge rounded-1 style-bg-dark-green style-text-no-limit ms-1 style-height-fit-content">
                                Não Regulamentada
                              </span>
                            </>
                          )}
                        </label>
                      </div>
                    );
                  })}
              </div>

              <div className="w-100 pe-2 mt-3 mb-2">
                {allBetHome &&
                  filteredSportsbookBetHome.map((value, index) => {
                    let nameBetHomeFilterLower = value.toLowerCase();
                    let isEnableWarning =
                      nameBetHomeFilterLower in warningBetHome ? true : false;

                    return index === 0 ? (
                      <React.Fragment key={index}>
                        <h4 className="ms-3 mode-h4">Sportsbook</h4>
                        <div
                          className={`form-check gap-2 ms-4 d-flex align-items-center ${
                            statusMode ? "textGray" : ""
                          }`}
                        >
                          <input
                            type="checkbox"
                            id={"casasDeApostasSportsbook" + index}
                            className={`form-check-input ${
                              requiredBetHomeFrontEnd.includes(
                                nameBetHomeFilterLower,
                              ) === true
                                ? "cus"
                                : ""
                            }`}
                            name={nameBetHomeFilterLower}
                            checked={
                              typeof betHomeFrontEnd === "object" &&
                              betHomeFrontEnd &&
                              betHomeFrontEnd.includes(nameBetHomeFilterLower)
                            }
                            onChange={EnabledDisablebBethome}
                          />

                          {nameBetHomeFilterLower in warningBetHome ? (
                            <img
                              data-tooltip-content={
                                isEnableWarning
                                  ? warningBetHomeMessages[
                                      warningBetHome[nameBetHomeFilterLower]
                                    ]
                                  : undefined
                              }
                              data-tooltip-id={
                                isEnableWarning ? "tooltip-surebet" : undefined
                              }
                              className="style-icon-alert-filter"
                              src={
                                warningBetHomeIcons[
                                  warningBetHome[nameBetHomeFilterLower]
                                ]
                              }
                            />
                          ) : (
                            ""
                          )}

                          <label
                            title=""
                            htmlFor={"casasDeApostasSportsbook" + index}
                            className="form-check-label white-space-nowrap d-flex"
                            name={nameBetHomeFilterLower}
                          >
                            <span className="nameBetHomeLabelDesktop">
                              {value}
                            </span>
                            {newListBetHome.includes(nameBetHomeFilterLower) ===
                            true ? (
                              <span
                                class="badge rounded-1 text-bg-warning ms-1 style-height-fit-content"
                                style={{ fontSize: "8px" }}
                              >
                                New
                              </span>
                            ) : (
                              ""
                            )}

                            {betHomeNoLimit.includes(
                              nameBetHomeFilterLower,
                            ) && (
                              <>
                                <span class="badge rounded-1 style-bg-dark-green style-text-no-limit ms-1 style-height-fit-content">
                                  Não Limita
                                </span>
                              </>
                            )}

                            {listBettingHousesUnregulated.includes(
                              nameBetHomeFilterLower,
                            ) && (
                              <>
                                <span class="badge rounded-1 style-bg-dark-green style-text-no-limit ms-1 style-height-fit-content">
                                  Não Regulamentada
                                </span>
                              </>
                            )}
                          </label>
                        </div>
                      </React.Fragment>
                    ) : (
                      <div
                        className={`form-check gap-2 ms-4 d-flex align-items-center ${
                          statusMode ? "textGray" : ""
                        }`}
                        key={index}
                      >
                        <input
                          type="checkbox"
                          id={"casasDeApostasSportsbook" + index}
                          className={`form-check-input ${
                            requiredBetHomeFrontEnd.includes(
                              value.toLowerCase(),
                            ) === true
                              ? "cus"
                              : ""
                          }`}
                          name={value.toLowerCase()}
                          checked={
                            typeof betHomeFrontEnd === "object" &&
                            betHomeFrontEnd &&
                            betHomeFrontEnd.includes(value.toLowerCase())
                          }
                          onChange={EnabledDisablebBethome}
                        />

                        {nameBetHomeFilterLower in warningBetHome ? (
                          <img
                            data-tooltip-content={
                              isEnableWarning
                                ? warningBetHomeMessages[
                                    warningBetHome[nameBetHomeFilterLower]
                                  ]
                                : undefined
                            }
                            data-tooltip-id={
                              isEnableWarning ? "tooltip-surebet" : undefined
                            }
                            className="style-icon-alert-filter"
                            src={
                              warningBetHomeIcons[
                                warningBetHome[nameBetHomeFilterLower]
                              ]
                            }
                          />
                        ) : (
                          ""
                        )}

                        <label
                          title=""
                          htmlFor={"casasDeApostasSportsbook" + index}
                          className="form-check-label white-space-nowrap d-flex d-flex"
                          name={value.toLowerCase()}
                        >
                          <span className="nameBetHomeLabelDesktop">
                            {value}
                          </span>
                          {newListBetHome.includes(nameBetHomeFilterLower) ===
                          true ? (
                            <span
                              class="badge rounded-1 text-bg-warning ms-1 style-height-fit-content"
                              style={{ fontSize: "8px" }}
                            >
                              New
                            </span>
                          ) : (
                            ""
                          )}

                          {betHomeNoLimit.includes(nameBetHomeFilterLower) && (
                            <>
                              <span class="badge rounded-1 style-bg-dark-green style-text-no-limit ms-1 style-height-fit-content">
                                Não Limita
                              </span>
                            </>
                          )}

                          {listBettingHousesUnregulated.includes(
                            nameBetHomeFilterLower,
                          ) && (
                            <>
                              <span class="badge rounded-1 style-bg-dark-green style-text-no-limit ms-1 style-height-fit-content">
                                Não Regulamentada
                              </span>
                            </>
                          )}
                        </label>
                      </div>
                    );
                  })}
              </div>
            </div>
            {!hasAnyBetHomeResult && searchTerm && (
              <div className="text-center py-3 px-2">
                <span className={statusMode ? "textGray" : "text-secondary"}>
                  Nenhuma casa de apostas encontrada.
                </span>
              </div>
            )}
          </div>
          <div
            className={`border-top ps-0 py-1 d-flex gap-2  ${
              statusMode ? "bgDark borderColor textGray" : ""
            }`}
          >
            <Tooltip
              id="tooltip-surebet"
              data-tooltip-place="top"
              style={{ maxWidth: "100%" }}
            />
            <input
              type="checkbox"
              id="show_all_bet_home"
              className="form-check-input ms-3"
              checked={
                betHomeFrontEnd && betHomeFrontEnd.length === quantityAllBetHome
              }
              onChange={markAll}
            />

            <label
              title=""
              htmlFor="show_all_bet_home"
              className="form-check-label "
              onChange={markAll}
            >
              Mostrar Tudo
            </label>
          </div>

          <div
            className={`modal-footer  ${
              statusMode ? "bgDark borderColor textGray" : ""
            }`}
          >
            <button
              type="button"
              className={`btn btn-primary ${statusMode ? "" : ""}`}
              data-bs-dismiss="modal"
              onClick={() => {
                saveFilterBetHome(betHomeFrontEnd, true);
              }}
            >
              Aplicar e filtrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
